<template>
  <div class="row main-content">
    <div class="col">
      <div
        v-if="isProcessing"
        class="text-center"
      >
        <img
          src="@/assets/img/loader.gif"
          class="mx-auto d-block center-block"
        >
      </div>

      <div v-else>
        <h1 class="page-title font-custom text-uppercase mt-3">
          {{ $t("title.clearing.details") }}
        </h1>

        <div
          v-if="responseErr"
          class="alert alert-danger text-center border-0 shadow-sm rounded-0"
        >
          <strong>
            {{ $t('error.'+`${responseErr}`) }}
          </strong>
        </div>

        <div class="card card-body bg-light mb-4">
          <button
            type="button"
            class="btn btn-primary rounded-pill font-custom font-inverted btn-export"
            @click="downloadCSV()"
          >
            <i class="far fa-file-excel me-1" />
            {{ $t('button.export') }}
          </button>
        </div>

        <div v-if="$store.state.clearings.clearing">
          <div
            id="accordionGeneralData"
            class="card rounded-0 mb-4"
          >
            <div
              id="headingGeneralData"
              data-bs-toggle="collapse"
              href="#collapseGeneralData"
              aria-expanded="true"
              aria-controls="collapseGeneralData"
              class="card-header font-accent fw-bold"
            >
              {{ $t("label.clearing.detail.transaction.generalData") }}
            </div>
            <div
              id="collapseGeneralData"
              aria-labelledby="headingGeneralData"
              data-bs-parent="#accordionGeneralData"
              class="card-body collapse show"
            >
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.idOperation") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.idOperation }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.classeTransaction") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.classeTransaction }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.transactionType") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.transactionType }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.technicalStatus") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.technicalStatus }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.clearingStatus") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.clearingStatus }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.clearingReason") }}
                </div>
                <div class="col">
                  <!--à changer en clearingReason une fois que backOfficeFolderName aura disparu-->
                  {{ clearing.transaction.backofficeFolderName }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.technicalErrorType") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.technicalErrorType }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.technicalErrorDetail") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.technicalErrorDetail }}
                </div>
              </div>

              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.matchingAlgorithm") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.matchingAlgorithm && clearing.transaction.matchingAlgorithm.algorithm ? clearing.transaction.matchingAlgorithm.algorithm : '' }}
                  {{ clearing.transaction.matchingAlgorithm && clearing.transaction.matchingAlgorithm.level ? $t("label.clearing.detail.transaction.level") : '' }}
                  {{ clearing.transaction.matchingAlgorithm && clearing.transaction.matchingAlgorithm.level ? clearing.transaction.matchingAlgorithm.level : '' }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.authorizationNotFound") }}
                </div>
                <div class="col">
                  {{ $filters.boolean(clearing.transaction.authorizationNotFound) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.authorizationOrigin") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.numAut }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.authorizationReference") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.authorizationReference }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.idOperationAlreadyMatched") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.idOperationAlreadyMatched }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.authorizationReferenceList") }}
                </div>
                <div
                  v-if="clearing.transaction.authorizationReferenceList && clearing.transaction.authorizationReferenceList.authorizationReference"
                  class="col"
                >
                  <div
                    v-for="authorizationReference in clearing.transaction.authorizationReferenceList.authorizationReference"
                    :key="authorizationReference"
                  >
                    {{ authorizationReference }} <br>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.dateTransaction") }}
                </div>
                <div class="col">
                  {{ $filters.date(clearing.transaction.dateTransaction) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.transmissionDateAndTime") }}
                </div>
                <div class="col">
                  {{ $filters.date(clearing.transaction.transmissionDateAndTime) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.processingDate") }}
                </div>
                <div class="col">
                  {{ $filters.date(clearing.transaction.processingDate) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.transactionAmount") }}
                </div>
                <div class="col">
                  {{ $filters.amountObject(clearing.transaction.transactionAmount) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.reconciliationAmount") }}
                </div>
                <div class="col">
                  {{ $filters.amountObject(clearing.transaction.reconciliationAmount) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.retrievalReferenceNumber") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.retrievalReferenceNumber }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.transactionStatus") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.transactionStatus }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.rejectReasonCode") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.rejectReasonCode }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.partialFlag") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.partialFlag }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.claimCbkId") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.claimCbkId }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.cbkId") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.cbkId }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.cardIssuerReferenceData") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.cardIssuerReferenceData }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.reasonCode") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.reasonCode }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.messageText") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.messageText }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.reversalFlag") }}
                </div>
                <div class="col">
                  {{ $filters.boolean(clearing.transaction.reversalFlag) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.originalIdOperation") }}
                </div>
                <div class="col">
                  <template v-if="clearing.transaction.originalIdOperation">
                    <div
                      role="button"
                      class="clickable-div"
                      @click="showClearing(clearing.transaction.originalIdOperation)"
                    >
                      {{ clearing.transaction.originalIdOperation }}
                    </div>
                  </template>
                  <template v-else>
                    {{ clearing.transaction.originalIdOperation }}
                  </template>
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.direction") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.direction }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.collectionDisbursementFlag") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.collectionDisbursementFlag }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.typeFacture") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.typeFacture }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.accountholderAuthenticationValue") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.accountholderAuthenticationValue }}
                </div>
              </div>
            </div>
          </div>

          <div
            id="accordionEmetteur"
            class="card rounded-0 mb-4"
          >
            <div
              id="headingEmetteur"
              data-bs-toggle="collapse"
              href="#collapseEmetteur"
              aria-expanded="false"
              aria-controls="collapseEmetteur"
              class="card-header font-accent fw-bold"
            >
              {{ $t("label.clearing.detail.transaction.emetteur") }}
            </div>

            <div
              id="collapseEmetteur"
              aria-labelledby="headingEmetteur"
              data-bs-parent="#accordionEmetteur"
              class="card-body collapse"
            >
              <div id="emetteur-accordion">
                <div
                  id="accordionDataDistrib"
                  class="card rounded-0 mb-4"
                >
                  <div
                    id="headingDataDistrib"
                    data-bs-toggle="collapse"
                    href="#collapseDataDistrib"
                    aria-expanded="true"
                    aria-controls="collapseDataDistrib"
                    class="card-header font-accent fw-bold"
                  >
                    {{ $t("label.clearing.detail.transaction.distributorData") }}
                  </div>
                  <div
                    id="collapseDataDistrib"
                    aria-labelledby="headingDataDistrib"
                    data-bs-parent="#accordionDataDistrib"
                    class="card-body collapse show"
                  >
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.issuerId") }}
                      </div>
                      <div class="col">
                        {{ clearing.transaction.issuerId }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.distributorRef") }}
                      </div>
                      <div class="col">
                        {{ clearing.transaction.distributorRef }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.memberId") }}
                      </div>
                      <div class="col">
                        {{ clearing.transaction.memberId }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{
                          $t(
                            "label.clearing.detail.transaction.memberIdRec"
                          )
                        }}
                      </div>
                      <div class="col">
                        {{ clearing.transaction.memberIdRec }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.cardSchemeCode") }}
                      </div>
                      <div class="col">
                        {{ clearing.transaction.cardSchemeCode }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.technicalProduct") }}
                      </div>
                      <div class="col">
                        {{ clearing.transaction.technicalProduct }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.brand") }}
                      </div>
                      <div class="col">
                        {{ clearing.transaction.brand }}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  id="accordionDataBenef"
                  class="card rounded-0 mb-4"
                >
                  <div
                    id="headingDataBenef"
                    data-bs-toggle="collapse"
                    href="#collapseDataBenef"
                    aria-expanded="true"
                    aria-controls="collapseDataBenef"
                    class="card-header font-accent fw-bold"
                  >
                    {{ $t("label.clearing.detail.transaction.beneficiary") }}
                  </div>
                  <div
                    id="collapseDataBenef"
                    aria-labelledby="headingDataBenef"
                    data-bs-parent="#accordionDataBenef"
                    class="card-body collapse show"
                  >
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.pan") }}
                      </div>
                      <div class="col">
                        {{ clearing.transaction.pan }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.cardId") }}
                      </div>
                      <div class="col">
                        {{ clearing.transaction.cardId }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.expiryDate") }}
                      </div>
                      <div class="col">
                        {{ clearing.transaction.expiryDate }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.psn") }}
                      </div>
                      <div class="col">
                        {{ clearing.transaction.psn }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.productExternalReference") }}
                      </div>
                      <div
                        v-if="clearing.beneficiary"
                        class="col"
                      >
                        {{ clearing.beneficiary.productExternalReference }}
                      </div>
                      <div
                        v-else
                        class="col"
                      >
                        --
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.cardStatus") }}
                      </div>
                      <div class="col">
                        {{ clearing.transaction.cardStatus }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.beneficiaryServiceExternalReference") }}
                      </div>
                      <div
                        v-if="clearing.beneficiary"
                        class="col"
                      >
                        {{ clearing.beneficiary.beneficiaryServiceExternalReference }}
                      </div>
                      <div
                        v-else
                        class="col"
                      >
                        --
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.libServiceBenef") }}
                      </div>
                      <div class="col">
                        {{ clearing.transaction.libServiceBenef }}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  id="accordionDataFinanceur"
                  class="card rounded-0 mb-4"
                >
                  <div
                    id="headingDataFinanceur"
                    data-bs-toggle="collapse"
                    href="#collapseDataFinanceur"
                    aria-expanded="true"
                    aria-controls="collapseDataFinanceur"
                    class="card-header font-accent fw-bold"
                  >
                    {{ $t("label.clearing.detail.transaction.funder") }}
                  </div>
                  <div
                    id="collapseDataFinanceur"
                    aria-labelledby="headingDataFinanceur"
                    data-bs-parent="#accordionDataFinanceur"
                    class="card-body collapse show"
                  >
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.funder.label") }}
                      </div>
                      <div
                        v-if="clearing.funder"
                        class="col"
                      >
                        {{ clearing.funder.label }}
                      </div>
                      <div
                        v-else
                        class="col"
                      >
                        --
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.funder.funderContractRef") }}
                      </div>
                      <div
                        v-if="clearing.funder"
                        class="col"
                      >
                        {{ clearing.funder.funderContractRef }}
                      </div>
                      <div
                        v-else
                        class="col"
                      >
                        --
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.funder.libContratFinanceur") }}
                      </div>
                      <div
                        v-if="clearing.funder"
                        class="col"
                      >
                        {{ clearing.funder.libContratFinanceur }}
                      </div>
                      <div
                        v-else
                        class="col"
                      >
                        --
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{
                          $t("label.clearing.detail.funder.statutContratFinanceur")
                        }}
                      </div>
                      <div
                        v-if="clearing.funder"
                        class="col"
                      >
                        {{ clearing.funder.statutContratFinanceur }}
                      </div>
                      <div
                        v-else
                        class="col"
                      >
                        --
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{
                          $t("label.clearing.detail.funder.funderProfilRef")
                        }}
                      </div>
                      <div
                        v-if="clearing.funder"
                        class="col"
                      >
                        {{ clearing.funder.funderProfilRef }}
                      </div>
                      <div
                        v-else
                        class="col"
                      >
                        --
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            id="accordionAcquereur"
            class="card rounded-0 mb-4"
          >
            <div
              id="headingAcquereur"
              data-bs-toggle="collapse"
              href="#collapseAcquereur"
              aria-expanded="false"
              aria-controls="collapseAcquereur"
              class="card-header font-accent fw-bold"
            >
              {{ $t("label.clearing.detail.transaction.acquereur") }}
            </div>

            <div
              id="collapseAcquereur"
              aria-labelledby="headingAcquereur"
              data-bs-parent="#accordionAcquereur"
              class="card-body collapse"
            >
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.acquiringBIN") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.acquiringBIN }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.idContratAffilie") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.idContratAffilie }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.idMarchand") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.idMarchand }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.idStructure") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.idStructure }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.domesticAcceptorTaxId") }}
                </div>
                <div
                  class="col"
                  style="white-space: pre-wrap;"
                >
                  {{ clearing.transaction.acceptorTaxId }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.accountCategory") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.accountCategory }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.accountNumber") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.accountNumber }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.nomMarchand") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.nomMarchand }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.rueMarchand") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.rueMarchand }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.villeMarchand") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.villeMarchand }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.codepostalMarchand") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.codepostalMarchand }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.regionMarchand") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.regionMarchand }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.countryCode") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.countryCode }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.idTerminal") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.idTerminal }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.idAcceptation") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.idAcceptation }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.codeMCC") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.codeMCC }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.acquirerReferenceNumber") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.acquirerReferenceNumber }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.traceNumber") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.traceNumber }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.idRemise") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.idRemise }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.paymentFacilitatorId") }}
                </div>
                <div
                  class="col"
                  style="white-space: pre-wrap;"
                >
                  {{ clearing.transaction.paymentFacilitatorId }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.subMerchantId") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.subMerchantId }}
                </div>
              </div>
            </div>
          </div>

          <div
            id="accordionOperation"
            class="card rounded-0 mb-4"
          >
            <div
              id="headingOperation"
              data-bs-toggle="collapse"
              href="#collapseOperation"
              aria-expanded="false"
              aria-controls="collapseOperation"
              class="card-header font-accent fw-bold"
            >
              {{ $t("label.clearing.detail.transaction.detailOperation") }}
            </div>

            <div
              id="collapseOperation"
              aria-labelledby="headingOperation"
              data-bs-parent="#accordionOperation"
              class="card-body collapse"
            >
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.transactionType") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.transactionType }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.canalAcceptationValue") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.canalAcceptationValue }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.posEntryMode") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.posEntryMode }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{
                    $t("label.clearing.detail.transaction.transactionOriginatorInstitutionIdCode")
                  }}
                </div>
                <div class="col">
                  {{ clearing.transaction.transactionOriginatorInstitutionIdCode }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.transactionDestinationInstitutionIdCode") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.transactionDestinationInstitutionIdCode }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.dateTransaction") }}
                </div>
                <div class="col">
                  {{ $filters.date(clearing.transaction.dateTransaction) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.transactionAmount") }}
                </div>
                <div class="col">
                  {{ $filters.amountObject(clearing.transaction.transactionAmount) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.reconciliationAmount") }}
                </div>
                <div class="col">
                  {{ $filters.amountObject(clearing.transaction.reconciliationAmount) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.exchangeRate") }}
                </div>
                <div
                  v-if="clearing.transaction.exchangeRate"
                  class="col"
                >
                  {{ $filters.conversionRate(clearing.transaction.exchangeRate.rate, clearing.transaction.exchangeRate.exponent) }}
                </div>
                <div
                  v-else
                  class="col"
                >
                  --
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.cardHolderBillingAmount") }}
                </div>
                <div class="col">
                  {{ $filters.amountObject(clearing.transaction.cardHolderBillingAmount) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.cardholderConversionRate") }}
                </div>
                <div
                  v-if="clearing.transaction.cardholderConversionRate"
                  class="col"
                >
                  {{ $filters.conversionRate(clearing.transaction.cardholderConversionRate.rate, clearing.transaction.cardholderConversionRate.exponent) }}
                </div>
                <div
                  v-else
                  class="col"
                >
                  --
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.amountBeforeTopUp") }}
                </div>
                <div class="col">
                  {{ $filters.amountObject(clearing.transaction.amountBeforeTopUp) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.complementAmount") }}
                </div>
                <div class="col">
                  {{ $filters.amountObject(clearing.transaction.complementAmount) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.interchangeFees") }}
                </div>
                <div v-if="clearing.transaction.interchangeFees">
                  <div
                    v-for="interchangeFee in clearing.transaction.interchangeFees"
                    :key="interchangeFee.interchangeFeeCode"
                    class="col"
                  >
                    {{ interchangeFee.interchangeFeeCode }}: {{ $filters.amountObject(interchangeFee.interchangeFeeAmount) }}
                  </div>
                </div>
                <div
                  v-else
                  class="col"
                >
                  0
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.settlementDate") }}
                </div>
                <div class="col">
                  {{ $filters.date(clearing.transaction.settlementDate) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.authorizationOrigin") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.numAut }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{
                    $t("label.clearing.detail.transaction.traceId")
                  }}
                </div>
                <div class="col">
                  {{ clearing.transaction.traceId }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.clearing.detail.transaction.transactionLinkId') }}
                </div>
                <div class="col">
                  {{ clearing.transaction.transactionLinkID }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.clearing.detail.transaction.cardholderMerchantInitiatorTrInd') }}
                </div>
                <div class="col">
                  {{ clearing.transaction.cardholderMerchantInitTrxnInd }}
                </div>
              </div>

              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.originalIdOperation") }}
                </div>
                <div class="col">
                  <template v-if="clearing.transaction.originalIdOperation">
                    <div
                      role="button"
                      class="clickable-div"
                      @click="showClearing(clearing.transaction.originalIdOperation)"
                    >
                      {{ clearing.transaction.originalIdOperation }}
                    </div>
                  </template>
                  <template v-else>
                    {{ clearing.transaction.originalIdOperation }}
                  </template>
                </div>
              </div>

              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.directSettlementMode") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.directSettlementMode }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.directSettlementInformation") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.directSettlementInformation }}
                </div>
              </div>
            </div>
          </div>

          <div
            id="accordionImpactVoucher"
            class="card rounded-0 mb-4"
          >
            <div
              id="headingImpactVoucher"
              data-bs-toggle="collapse"
              href="#collapseImpactVoucher"
              aria-expanded="false"
              aria-controls="collapseImpactVoucher"
              class="card-header font-accent fw-bold"
            >
              {{ $t("label.clearing.detail.transaction.impactVoucher") }}
            </div>
            <div
              id="collapseImpactVoucher"
              aria-labelledby="headingImpactVoucher"
              data-bs-parent="#accordionImpactVoucher"
              class="card-body collapse"
            >
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.externalReference") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.externalReference }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.accountImpact") }}
                </div>
                <div class="col">
                  {{ $filters.boolean(clearing.transaction.accountImpact) }}
                </div>
              </div>
            </div>
          </div>

          <div
            id="accordionSecuData"
            class="card rounded-0 mb-4"
          >
            <div
              id="headingSecuData"
              data-bs-toggle="collapse"
              href="#collapseSecuData"
              aria-expanded="false"
              aria-controls="collapseSecuData"
              class="card-header font-accent fw-bold"
            >
              {{ $t("label.clearing.detail.transaction.donneesSecuritaires") }}
            </div>

            <div
              id="collapseSecuData"
              aria-labelledby="headingSecuData"
              data-bs-parent="#accordionSecuData"
              class="card-body collapse"
            >
              <div id="donne-sec-accordion">
                <div
                  id="accordionDataECM"
                  class="card rounded-0 mb-4"
                >
                  <div
                    id="headingDataECM"
                    data-bs-toggle="collapseDataECM"
                    aria-expanded="true"
                    aria-controls="collapseDataECM"
                    class="card-header font-accent fw-bold"
                  >
                    {{ $t("label.clearing.detail.transaction.ecommData") }}
                  </div>
                  <div
                    v-for="ecomm in clearing.transaction.ecomm"
                    id="collapseDataECM"
                    :key="ecomm.transacIdAcceptor"
                    aria-labelledby="headingDataECM"
                    data-bs-parent="#accordionDataECM"
                    class="card-body collapse show"
                  >
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.ecomm.transacIdAcceptor") }}
                      </div>
                      <div class="col">
                        {{ ecomm.transacIdAcceptor }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.ecomm.cardholderAuthMethod") }}
                      </div>
                      <div class="col">
                        {{ ecomm.cardholderAuthMethod }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.ecomm.indicator") }}
                      </div>
                      <div class="col">
                        {{ ecomm.indicator }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.ecomm.cryptogram") }}
                      </div>
                      <div class="col">
                        {{ ecomm.cryptogram }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.ecomm.cryptogramCalcMethod") }}
                      </div>
                      <div class="col">
                        {{ ecomm.cryptogramCalcMethod }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.ecomm.cryptogramProcessInfo") }}
                      </div>
                      <div class="col">
                        {{ ecomm.cryptogramProcessInfo }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.ecomm.resultUseSecArch") }}
                      </div>
                      <div class="col">
                        {{ ecomm.resultUseSecArch }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.ecomm.securityType") }}
                      </div>
                      <div class="col">
                        {{ ecomm.securityType }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.ecomm.modifiedSecurityMode") }}
                      </div>
                      <div class="col">
                        {{ ecomm.modifiedSecurityMode }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.ecomm.additionalData") }}
                      </div>
                      <div class="col">
                        {{ ecomm.additionalData }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.ecomm.securityProtocol") }}
                      </div>
                      <div class="col">
                        {{ ecomm.securityProtocol }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.ecomm.cardholderAuthentification") }}
                      </div>
                      <div class="col">
                        {{ ecomm.cardholderAuthentification }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.ecomm.ucafCollectionIndicator") }}
                      </div>
                      <div class="col">
                        {{ ecomm.ucafCollectionIndicator }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.ecomm.directoryServerTransactionId") }}
                      </div>
                      <div class="col">
                        {{ ecomm.directoryServerTransactionId }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.ecomm.programProtocol") }}
                      </div>
                      <div class="col">
                        {{ ecomm.programProtocol }}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  id="accordionDataMDES"
                  class="card rounded-0 mb-4"
                >
                  <div
                    id="headingDataMDES"
                    data-bs-toggle="collapse"
                    href="#collapseDataMDES"
                    aria-expanded="true"
                    aria-controls="collapseDataMDES"
                    class="card-header font-accent fw-bold"
                  >
                    {{ $t("label.clearing.detail.transaction.mdesData") }}
                  </div>
                  <div
                    v-if="clearing.transaction.xpay"
                    id="collapseDataMDES"
                    aria-labelledby="headingDataMDES"
                    data-bs-parent="#accordionDataMDES"
                    class="card-body collapse show"
                  >
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.xpay.tokenType") }}
                      </div>
                      <div class="col">
                        {{ clearing.transaction.xpay.tokenType }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.xpay.tokenAccountNumber") }}
                      </div>
                      <div class="col">
                        {{ clearing.transaction.xpay.tokenAccountNumber }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.xpay.tokenAssuranceLevel") }}
                      </div>
                      <div class="col">
                        {{ clearing.transaction.xpay.tokenAssuranceLevel }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.xpay.tokenRequestorId") }}
                      </div>
                      <div class="col">
                        {{ clearing.transaction.xpay.tokenRequestorId }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.xpay.deviceType") }}
                      </div>
                      <div class="col">
                        {{ clearing.transaction.xpay.deviceType }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t("label.clearing.detail.transaction.xpay.tokenWalletId") }}
                      </div>
                      <div class="col">
                        {{ clearing.transaction.xpay.tokenWalletId }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            id="accordionClearing"
            class="card rounded-0 mb-4"
          >
            <div
              id="headingClearing"
              data-bs-toggle="collapse"
              href="#collapseClearing"
              aria-expanded="false"
              aria-controls="collapseClearing"
              class="card-header font-accent fw-bold"
            >
              {{ $t("label.clearing.detail.transaction.donneesFichierCompensation") }}
            </div>

            <div
              id="collapseClearing"
              aria-labelledby="headingClearing"
              data-bs-parent="#accordionClearing"
              class="card-body collapse"
            >
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.dateFichier") }}
                </div>
                <div class="col">
                  {{ $filters.date(clearing.transaction.dateFichier) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.dateExtraction") }}
                </div>
                <div class="col">
                  {{ $filters.date(clearing.transaction.dateExtraction) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.statutExtraction") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.statutExtraction }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.fileId") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.fileId }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t("label.clearing.detail.transaction.numMessage") }}
                </div>
                <div class="col">
                  {{ clearing.transaction.numMessage }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.clearing.detail.transaction.incomingFileReference') }}
                </div>
                <div class="col">
                  {{ clearing.transaction.incomingFileReference }}
                  <span
                    v-if="clearing.transaction.incomingFileReference"
                    :title="$t('label.clearing.detail.transaction.settlementFileIdentifier')"
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    class="label label-default ms-2"
                  >
                    <i class="fa fa-info-circle fa-xs" />
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div
            id="accordionScpData"
            class="card rounded-0 mb-4"
          >
            <div
              id="headingScpData"
              data-bs-toggle="collapse"
              href="#collapseScpData"
              aria-expanded="false"
              aria-controls="collapseScpData"
              class="card-header font-accent fw-bold"
            >
              {{ $t('label.authorization.detail.scpSpeciData') }}
            </div>

            <div
              id="collapseScpData"
              aria-labelledby="headingScpData"
              data-bs-parent="#accordionScpData"
              class="card-body collapse"
            >
              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.authorization.detail.scpRequestDate') }}
                </div>
                <div
                  v-if="clearing.transaction.clearingPaymentComplement"
                  class="col"
                >
                  {{ $filters.date(clearing.transaction.clearingPaymentComplement.scpRequestDate) }}
                </div>
                <div
                  v-else
                  class="col"
                >
                  --
                </div>
              </div>
              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.authorization.detail.scpResponseDate') }}
                </div>
                <div
                  v-if="clearing.transaction.clearingPaymentComplement"
                  class="col"
                >
                  {{ $filters.date(clearing.transaction.clearingPaymentComplement.scpResponseDate) }}
                </div>
                <div
                  v-else
                  class="col"
                >
                  --
                </div>
              </div>
              <!-- div class="row">
              <div class="col-2 text-end">{{ $t('label.authorization.detail.substitutionPaymentReason') }}</div>
              <div v-if="clearing.transaction.clearingPaymentComplement" class="col">{{ clearing.transaction.clearingPaymentComplement.substitutionPaymentReason }}</div>
              <div v-else class="col"> -- </div>
            </div -->
              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.authorization.detail.scpResponseCode') }}
                </div>
                <div
                  v-if="clearing.transaction.clearingPaymentComplement"
                  class="col"
                >
                  {{ clearing.transaction.clearingPaymentComplement.scpResponseCode }}
                </div>
                <div
                  v-else
                  class="col"
                >
                  --
                </div>
              </div>
            </div>
          </div>
          <div
            id="accordionSaeData"
            class="card rounded-0 mb-4"
          >
            <div
              id="headingSaeData"
              data-bs-toggle="collapse"
              href="#collapseSaeData"
              aria-expanded="false"
              aria-controls="collapseSaeData"
              class="card-header font-accent fw-bold"
            >
              {{ $t('label.authorization.detail.extSaeSpeciData') }}
            </div>

            <div
              id="collapseSaeData"
              aria-labelledby="headingSaeData"
              data-bs-parent="#accordionSaeData"
              class="card-body collapse"
            >
              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.authorization.detail.accountUpdatableExtSae') }}
                </div>
                <div
                  v-if="clearing.transaction.accountImpactNeeded && clearing.transaction.accountImpactNeeded === true"
                  class="col"
                >
                  {{ $t('label.authorization.detail.accountUpdatableYes') }}
                </div>
                <div
                  v-else
                  class="col"
                >
                  {{ $t('label.authorization.detail.accountUpdatableNo') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./ClearingDetail.js"></script>

<style src="./ClearingDetail.scss" scoped lang="scss"></style>
